import { projectThumbnail } from '@/domain/export/thumbnail';
import type { ProjectDocument } from '@/domain/model/types';
import type { ProjectRepository } from '@/repositories/projectRepository';

/**
 * Stores the gallery preview for a saved revision. Previews are disposable, so this
 * never fails the operation that called it (the repository swallows storage errors).
 */
export async function storeProjectThumbnail(
  repository: ProjectRepository,
  doc: ProjectDocument,
): Promise<void> {
  await repository.saveThumbnail(doc.id, doc.revision, projectThumbnail(doc, { showPolish: true }));
}
